import { SearchParams } from 'location.types'

export const isMaestroTest = (): boolean => {
  const maestroQueryValue = new URLSearchParams(window.location.search).get(
    SearchParams.MaestroTest
  )
  const storedMaestroFlag = localStorage.getItem(SearchParams.MaestroTest)

  return (maestroQueryValue ?? storedMaestroFlag) === 'true'
}
